// TREASURE BOX - Theme JS
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('tb-menu-toggle');
  var nav = document.getElementById('tb-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // 2026-10-29: 기존 "찜하기 버튼(비주얼 데모)" 핸들러는 제거했습니다.
  // 실제 위시리스트 로직(localStorage 저장/배지/패널)은
  // assets/tb-wishlist.js 에서 [data-tb-wish-id] 버튼을 대상으로 처리합니다.
  // (이 핸들러가 남아 있으면 btn.textContent를 덮어써서 하트 SVG 아이콘이
  // 사라지는 충돌이 발생하므로 완전히 제거했습니다.)

  // ------------------------------------------------------------------
  // 2026-10-12 추가: 헤더 데스크톱 드롭다운 메뉴(.header__inline-menu)
  // 좌우 클릭형 스크롤 버튼 + 하위 메뉴(드롭다운) 패널 위치 보정.
  //
  // [배경] 영어/일본어처럼 메뉴 텍스트가 길어지는 990px~1780px 구간에서는
  // 메뉴(.header__inline-menu)에 overflow-x:auto를 적용해 가로 스크롤로
  // 넘치는 내용을 처리합니다(treasurebox.css). 그런데:
  //   1) 트랙패드/마우스 가로 드래그로만 스크롤되어 조작이 어렵다는 피드백
  //      → 좌우 끝에 클릭 버튼(‹ ›)을 추가해 스크롤 가능하도록 함.
  //   2) overflow-x:auto는 CSS 스펙상 overflow-y도 강제로 clip(hidden/auto)
  //      시키므로, 하위 메뉴가 있는 항목("Premium Toys" 등)을 클릭해도
  //      드롭다운 패널이 메뉴 영역 밖(세로 방향)으로 보이지 못하고 잘려서
  //      전혀 보이지 않는 2차 버그가 있었음 → 드롭다운이 열릴 때 패널을
  //      position:fixed로 전환해 스크롤 컨테이너 밖으로 꺼내어 표시합니다.
  // ------------------------------------------------------------------
  (function () {
    var navEl = document.querySelector('.header__inline-menu');
    var wrapEl = document.querySelector('.tb-menu-scroll-wrap');
    if (!navEl || !wrapEl) return;

    var prevBtn = wrapEl.querySelector('.tb-menu-scroll-btn--prev');
    var nextBtn = wrapEl.querySelector('.tb-menu-scroll-btn--next');

    // --- (1) 좌우 스크롤 버튼 ---------------------------------------
    function updateButtons() {
      if (!prevBtn || !nextBtn) return;
      // 990px 미만(모바일/태블릿 드로어 메뉴)에서는 .header__inline-menu
      // 자체가 숨겨져 scrollWidth 계산이 의미 없으므로 버튼도 숨김.
      if (window.innerWidth < 990) {
        prevBtn.classList.remove('is-visible');
        nextBtn.classList.remove('is-visible');
        return;
      }
      var maxScroll = navEl.scrollWidth - navEl.clientWidth;
      // 스크롤할 내용이 거의 없으면(1px 오차 허용) 버튼 자체를 숨겨
      // 한국어처럼 메뉴가 폭 안에 다 들어가는 언어/화면에서는 기존과
      // 동일하게 보이도록 합니다.
      if (maxScroll <= 1) {
        prevBtn.classList.remove('is-visible');
        nextBtn.classList.remove('is-visible');
        return;
      }
      var scrollLeft = navEl.scrollLeft;
      prevBtn.classList.toggle('is-visible', scrollLeft > 1);
      nextBtn.classList.toggle('is-visible', scrollLeft < maxScroll - 1);
    }

    function scrollMenuBy(direction) {
      // 한 번 클릭 시 메뉴 보이는 폭의 60%만큼 이동(전체 메뉴를 몇 번의
      // 클릭으로 끝까지 볼 수 있으면서도, 이동 중인 항목을 놓치지 않을
      // 정도의 적당한 보폭).
      var amount = Math.max(navEl.clientWidth * 0.6, 120);
      navEl.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollMenuBy(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollMenuBy(1);
      });
    }

    navEl.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
    // 폰트/웹폰트 로딩 등으로 레이아웃이 뒤늦게 확정되는 경우를 대비해
    // 로드 완료 후 한 번 더 재계산합니다.
    window.addEventListener('load', updateButtons);

    // --- (2) 하위 메뉴 드롭다운 패널 위치 보정 ------------------------
    // 대상: 상위 메뉴 중 하위 메뉴가 연결된 모든 <details>(동적으로
    // Shopify Admin 내비게이션에서 하위 메뉴가 추가되는 모든 항목에
    // 자동으로 적용되며, "브랜드별 쇼핑"처럼 전용 클래스가 붙은 항목도
    // 동일 구조라 함께 적용됩니다). 2단계 중첩(하위의 하위) 드롭다운도
    // 동일한 header__submenu 구조이므로 querySelectorAll로 전체 포함.
    var allDetails = navEl.querySelectorAll('header-menu details, .tb-brand-menu details');

    function positionSubmenu(details) {
      var summary = details.querySelector(':scope > summary');
      var submenu = details.querySelector(':scope > .header__submenu');
      if (!summary || !submenu) return;
      var rect = summary.getBoundingClientRect();
      // list-menu--disclosure의 기본 CSS는 min-width:100%(가장 가까운
      // position:relative 조상인 summary 폭 기준)인데, position:fixed로
      // 전환하면 100%의 기준이 뷰포트로 바뀌어버려 패널이 화면 전체
      // 폭으로 늘어나는 2차 버그가 생깁니다. position 전환 '전에' 현재
      // 계산된 폭을 px로 고정해 의도한 폭을 그대로 유지합니다.
      submenu.style.minWidth = rect.width + 'px';
      submenu.style.position = 'fixed';
      submenu.style.top = rect.bottom + 'px';
      submenu.style.margin = '0';

      // 화면 우측 끝에 가까운 메뉴("브랜드별 쇼핑" 등)는 패널이 그대로
      // summary 왼쪽 기준으로 붙으면 뷰포트 밖으로 넘칠 수 있어, 필요한
      // 경우에만 좌측으로 당겨 화면 안에 들어오도록 보정합니다.
      var subWidth = submenu.offsetWidth;
      var margin = 8;
      var left = rect.left;
      if (left + subWidth > window.innerWidth - margin) {
        left = window.innerWidth - subWidth - margin;
      }
      if (left < margin) left = margin;
      submenu.style.left = left + 'px';
    }

    function clearSubmenu(details) {
      var submenu = details.querySelector(':scope > .header__submenu');
      if (!submenu) return;
      submenu.style.position = '';
      submenu.style.top = '';
      submenu.style.left = '';
      submenu.style.margin = '';
      submenu.style.minWidth = '';
    }

    allDetails.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          positionSubmenu(details);
        } else {
          clearSubmenu(details);
        }
      });
    });

    // 창 크기 변경 시 열려 있는 드롭다운이 있으면 위치 재계산.
    window.addEventListener('resize', function () {
      allDetails.forEach(function (details) {
        if (details.open) positionSubmenu(details);
      });
    });
  })();
});
